import styled from "styled-components";

export const Container = styled.div`
position: relative;
height: 150px;
display: flex;
align-items: center;
justify-content: center;

`


export const Image = styled.img`
 height: 120px;
  width: 120px;
  border-radius: 50%;
  border: 4px solid ${props => props.theme.siteColor};
  position: absolute;
  opacity: ${props => props.showimg === "true" ? 1 : 0};
  transition: all .5s;
`

export const Description = styled.div`
 text-align: center;
 opacity: ${props => props.showimg === "true" ? 0 : 1};
 transition: all .5s;

 h3 {
  font-size: 18px;
  padding: 5px;
  color: ${props => props.theme.siteColor};
}

p {
  color: ${props => props.theme.textMenuColor};
  font-size: 14px;
  
}

`


export const Menu = styled.nav`

background-color: ${props => props.theme.backgroundColorNavFooter};
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 2;

 
  ul {
  display: flex;
  width: 40%;
  justify-content: space-around;
 
}

li {
  padding: 20px;
  list-style: none;
}

li:hover {
  color: ${props => props.theme.hover};
}

`
export const Icon = styled.img`
  width: 60px;
  margin-right: 10%;
  cursor: pointer;

`
export const NavStyled = styled.nav`
background-color: ${props => props.theme.backgroundColorNavFooter};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: sticky;
  top: 0;
  z-index: 2;



  ul {
  display: flex;
  flex-direction: column;
}

li {
  list-style: none;
  padding: 22px;
  padding-left: 40px;
}
`

export const MenuResponsive = styled.div`

  display: flex;
  align-items: ${props => props.hidemenu === "true" ? "flex-start" : "center"};;
  justify-content: ${props => props.hidemenu === "true" ? "space-between" : "flex-end"};;
 height: ${props => props.hidemenu === "true" ? "400px" : "100px"};
  width: 100%;

 

`